module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_copy-83476edc7849a2cfe1a49e7fa7e4bba3.svg";